import * as React from 'react';
import { css } from 'aphrodite';
import styles from 'login-components/Common/svg/SVGStyles';

export default class SpecialtyVehicleRVSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 100 100"
        focusable="false"
      >
        <g>
          <path
            className={css(styles.grey)}
            d="M55.738,59.077a5.943,5.943,0,1,1-5.905,5.942A5.925,5.925,0,0,1,55.738,59.077Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M86.144,34.9H59.89c-15.716,0-20.143,22.79-18.964,22.265l-9.493,9.037a.585.585,0,0,0,.586.585H66.658c-.016-.194-.03-.389-.03-.586a7.151,7.151,0,0,1,14.3,0c0,.2-.014.392-.029.586h7.937a.585.585,0,0,0,.585-.585V38.183A3.279,3.279,0,0,0,86.144,34.9ZM82.519,52.092a1.861,1.861,0,0,1-1.855,1.856H75.7a1.861,1.861,0,0,1-1.856-1.856V44.549A1.861,1.861,0,0,1,75.7,42.694h4.964a1.861,1.861,0,0,1,1.855,1.855Z"
          />
          <rect className={css(styles.actionAccent)} x="73.258" y="47.675" width="9.884" height="1.172" rx="0.586" />
          <path
            className={css(styles.action)}
            d="M67.5,34.9H43.424a25.206,25.206,0,0,0-25.2,25.206v6.163a.518.518,0,0,0,.519.518H42.809a.518.518,0,0,1-.519-.518V60.11A25.206,25.206,0,0,1,67.5,34.9ZM38.259,54.912H23.253a16.482,16.482,0,0,1,5.315-10.707H43.417S38.962,49.206,38.259,54.912Z"
          />
          <rect className={css(styles.actionAccent)} x="24.129" y="48.711" width="16.507" height="1.172" rx="0.586" />
          <path
            className={css(styles.actionAccent)}
            d="M21.474,40.379l-.557-1.488a5.122,5.122,0,0,0-1.247-1.682l-1.026-.775,1-.64a3.974,3.974,0,0,0,1.27-1.815l.557-1.49.467,1.49a4.556,4.556,0,0,0,1.343,1.789l1.019.666-.889.6a4.723,4.723,0,0,0-1.328,1.743Z"
          />
          <path
            className={css(styles.action)}
            d="M13.492,47.174l-.835-2.23a7.665,7.665,0,0,0-1.87-2.523L9.249,41.258l1.5-.959a5.96,5.96,0,0,0,1.9-2.721l.835-2.235.7,2.235a6.815,6.815,0,0,0,2.013,2.682l1.528,1-1.333.9a7.044,7.044,0,0,0-1.991,2.615Z"
          />
          <path
            className={css(styles.grey)}
            d="M76.706,66.443A2.839,2.839,0,1,0,73.867,69.3,2.847,2.847,0,0,0,76.706,66.443Zm3.3,0a6.144,6.144,0,1,1-6.144-6.182A6.164,6.164,0,0,1,80.011,66.443Z"
          />
          <path
            className={css(styles.action)}
            d="M66.769,66.387c0-.22.013-.436.033-.651H64.176a1.685,1.685,0,0,0,.02-.2V46.385a1.648,1.648,0,0,0-1.643-1.644h-6.62a1.649,1.649,0,0,0-1.644,1.644V65.534a1.5,1.5,0,0,0,.021.2H17.954a.431.431,0,0,0-.431.431V67.3a.431.431,0,0,0,.431.431H66.9A7.068,7.068,0,0,1,66.769,66.387Z"
          />
          <path
            className={css(styles.action)}
            d="M89.813,65.736H80.921c.019.215.033.431.033.651a7.15,7.15,0,0,1-.131,1.342h8.99a.43.43,0,0,0,.43-.431V66.167A.43.43,0,0,0,89.813,65.736Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M29.38,65.65H13.492a.32.32,0,0,0-.32.321v1.4a.32.32,0,0,0,.32.32h8.876v2.678H18.356a.886.886,0,0,0,0,1.772h4.436A1.347,1.347,0,0,0,24.139,70.8v-3.1H29.38a.321.321,0,0,0,.321-.32v-1.4A.321.321,0,0,0,29.38,65.65Z"
          />
          <path
            className={css(styles.grey)}
            d="M18.991,71.324a1.345,1.345,0,1,0-1.345,1.353A1.35,1.35,0,0,0,18.991,71.324Zm1.566,0a2.911,2.911,0,1,1-2.911-2.93A2.92,2.92,0,0,1,20.557,71.324Z"
          />
          <rect className={css(styles.white)} x="55.947" y="46.551" width="6.756" height="7.199" rx="1.41" />
        </g>
      </svg>
    );
  }
}
